(function(){
  'use strict';
  var SEC = (document.currentScript && document.currentScript.dataset.section) ||
            'template--31364631036252__cart-section';
  var t, corps, ouvert = false;

  function prets(){ t = document.getElementById('gmt');
    corps = t && t.querySelector('[data-gmt-corps]'); return !!t; }

  // Le panier est rendu par Shopify : son minuteur, sa jauge, son order bump et
  // sa remise viennent du serveur. Il faut donc l'aller chercher — mais une
  // seule fois, et le plus tôt possible. D'où les deux gestes ci-dessous :
  // « /cart/add.js » renvoie la section dans SA réponse (paramètre sections),
  // et le panier non vide est préchargé dès l'arrivée sur la page.
  var enCache = null;

  function poser(html){
    // Le CSS de la page panier verrouille html et body dès qu'un .cart-page
    // existe : on neutralise ces deux règles-là dans le texte, avant de le
    // poser. desarmerVerrou() s'occupe de celles déjà présentes dans le document.
    html = String(html).replace(/html:has\(\.cart-page\)/g, '.gmt-hors-tiroir')
                       .replace(/body:has\(\.cart-page\)/g, '.gmt-hors-tiroir');
    corps.innerHTML = html;
    // les scripts injectes ne s'executent pas seuls : on les rejoue
    corps.querySelectorAll('script').forEach(function(vieux){
      var s = document.createElement('script');
      // on recopie TOUS les attributs : sans type="module", un script
      // de module leve « Cannot use import statement outside a module »
      for (var i = 0; i < vieux.attributes.length; i++) {
        s.setAttribute(vieux.attributes[i].name, vieux.attributes[i].value);
      }
      if (!vieux.src) s.textContent = vieux.textContent;
      vieux.parentNode.replaceChild(s, vieux);
    });
    desarmerVerrou();
  }

  function demander(){
    return fetch('/cart?section_id=' + SEC, { headers:{ 'X-Requested-With':'XMLHttpRequest' }})
      .then(function(r){ return r.text(); });
  }

  function charger(html){
    if (html) { poser(html); enCache = html; return Promise.resolve(); }
    return demander()
      .then(function(h){ poser(h); enCache = h; })
      .catch(function(){ corps.innerHTML = '<p class="gmt__attente">Panier indisponible. ' +
        '<a href="/cart">Ouvrir la page panier</a></p>'; });
  }

  // Préchargement : dès que la page est là, si le panier n'est pas vide, on va
  // chercher son rendu en tâche de fond. L'ouverture par l'icône est alors
  // immédiate, et on rafraîchit derrière pour le minuteur.
  function precharger(){
    fetch('/cart.js', { headers:{ Accept:'application/json' }})
      .then(function(r){ return r.json(); })
      .then(function(c){ if (c && c.item_count > 0) return demander().then(function(h){ enCache = h; }); })
      .catch(function(){});
  }

  // 20/09/2026 — BUG signalé : entre le clic sur « Ajouter au panier » et
  // l'arrivée du panier, le tiroir montrait pendant une fraction de seconde le
  // contenu du chargement PRÉCÉDENT — souvent l'écran « Continuer vos achats »
  // du panier vide. On voyait donc son panier vide juste après avoir ajouté.
  // À chaque ouverture, le contenu périmé laisse la place à une attente neutre.
  var SQUELETTE = '<div class="gmt__skel" aria-hidden="true">' +
                  '<span class="gmt__skel-l gmt__skel-l--img"></span>' +
                  '<span class="gmt__skel-l"></span>' +
                  '<span class="gmt__skel-l gmt__skel-l--court"></span>' +
                  '<span class="gmt__skel-l gmt__skel-l--bouton"></span></div>' +
                  '<p class="gmt__attente">Un instant…</p>';

  function ouvrir(html){
    if (!prets()) return;
    var pret = html || enCache;
    if (corps) corps.innerHTML = pret ? '' : SQUELETTE;
    ouvert = true;
    t.classList.add('est-ouvert'); t.setAttribute('aria-hidden','false');
    document.documentElement.classList.add('gmt-ouvert');
    document.body.classList.add('gmt-ouvert');
    if (pret) {
      charger(pret);
      // le rendu en cache peut dater (le minuteur tourne) : on rafraîchit
      // derrière, sans que l'acheteur voie quoi que ce soit clignoter.
      if (!html) demander().then(function(h){ if (ouvert && h !== enCache) { enCache = h; poser(h); } }).catch(function(){});
    } else {
      charger();
    }
  }
  // 20/09/2026 — BUG : une fois le tiroir refermé, la page ne défilait plus.
  // La règle « html:has(.cart-page), body:has(.cart-page) { overflow:hidden
  // !important } » vient de la feuille de la page panier, et le remplacement
  // fait sur le HTML injecté ne l'attrape pas : elle est déjà posée dans le
  // document. Tant qu'un .cart-page existe dans le tiroir, html et body restent
  // verrouillés, tiroir ouvert ou non. On désarme la règle elle-même, une fois.
  function desarmerVerrou(){
    for (var i = 0; i < document.styleSheets.length; i++) {
      var regles; try { regles = document.styleSheets[i].cssRules; } catch (e) { continue; }
      for (var j = 0; j < regles.length; j++) {
        var r = regles[j];
        if (!r || !r.selectorText || r.selectorText.indexOf(':has(.cart-page)') === -1) continue;
        if (r.style) { r.style.removeProperty('overflow'); r.style.removeProperty('height'); }
      }
    }
    // Filet, au cas où un script poserait le verrou en style direct.
    if (!document.documentElement.classList.contains('gmt-ouvert')) {
      document.documentElement.style.removeProperty('overflow');
      document.body.style.removeProperty('overflow');
    }
  }

  function fermer(){
    if (!t) return;
    ouvert = false;
    t.classList.remove('est-ouvert'); t.setAttribute('aria-hidden','true');
    document.documentElement.classList.remove('gmt-ouvert');
    document.body.classList.remove('gmt-ouvert');
    enCache = null;
    desarmerVerrou();
    precharger();
  }

  document.addEventListener('click', function(e){
    if (e.target.closest('[data-gmt-fermer]')) { e.preventDefault(); fermer(); return; }
    // 20/09/2026 — « Continuer vos achats », dans le panier vide, renvoyait à
    // la boutique. Depuis un tiroir, continuer ses achats, c'est rester là où
    // l'on est : le lien referme le tiroir, rien de plus.
    var retour = e.target.closest('#gmt .cart-items__empty-button, #gmt a[href$="/collections/boutique"], #gmt a[href="/collections/all"]');
    if (retour) { e.preventDefault(); e.stopPropagation(); fermer(); return; }
    // l'icone panier de l'en-tete ouvre le tiroir au lieu de changer de page
    // l'icone du theme Horizon est un bouton « #cart-drawer/toggle » : il ouvrait
    // le tiroir du theme, qui POUSSE la page (1000 -> 520 px mesures le 15/09/2026).
    var ic = e.target.closest('a[href$="/cart"], a[href*="/cart?"], #cart-icon-bubble, .header__icon--cart, cart-icon, [on\\:click*="#cart-drawer"]');
    if (ic && !ic.closest('#gmt') && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
      e.preventDefault(); e.stopPropagation(); ouvrir();
    }
  }, true);

  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && ouvert) fermer(); });

  // on intercepte l'ajout au panier : l'acheteur ne quitte plus la fiche
  document.addEventListener('submit', function(e){
    var f = e.target;
    if (!f || f.tagName !== 'FORM') return;
    var action = f.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    e.preventDefault(); e.stopPropagation();
    var btn = f.querySelector('[name="add"]');
    if (btn) btn.setAttribute('aria-busy','true');
    var donnees = new FormData(f);
    // Shopify renvoie le rendu d'une section dans la réponse de l'ajout : une
    // seule requête au lieu de deux, donc le panier est là dès l'ouverture.
    donnees.append('sections', SEC);
    fetch('/cart/add.js', { method:'POST', headers:{ Accept:'application/json' },
                            body: donnees })
      .then(function(r){ return r.json(); })
      .then(function(d){ ouvrir(d && d.sections && d.sections[SEC]); })
      .catch(function(){ f.submit(); })
      .finally(function(){ if (btn) btn.removeAttribute('aria-busy'); });
  }, true);

  // Filet : si le tiroir du theme s'ouvre malgre tout (ouverture automatique,
  // autre bouton), on le referme et on ouvre celui-ci, qui se superpose.
  function surveiller(){
    var d = document.querySelector('#cart-drawer dialog');
    if (!d || d.dataset.gmtVeille) return;
    d.dataset.gmtVeille = '1';
    // Mesure du 15/09/2026 : le close() du composant du theme laisse le
    // dialogue « open ». On ferme donc le dialogue natif, puis on recontrole,
    // car le theme peut le rouvrir juste apres son animation.
    function fermerTheme(){
      if (!d.open) return;
      var td = document.getElementById('cart-drawer');
      try { if (td && typeof td.close === 'function') td.close(); } catch (e) {}
      if (d.open) HTMLDialogElement.prototype.close.call(d);
    }
    new MutationObserver(function(){
      if (!d.open) return;
      fermerTheme();
      setTimeout(fermerTheme, 60); setTimeout(fermerTheme, 400);
      if (!ouvert) ouvrir();
    }).observe(d, { attributes: true, attributeFilter: ['open'] });
  }
  function demarrer(){ prets(); surveiller(); precharger(); }
  if (document.readyState !== 'loading') demarrer();
  else document.addEventListener('DOMContentLoaded', demarrer);
})();
